import Rule from "./Rule";
import { Heading, Flex } from "@chakra-ui/react";
import ruleInfo from "../../data/rules.json";
import teamRules from "../../data/teamRules.json";
import cutthroatRules from "../../data/cutthroatRules.json";
import { nanoid } from "nanoid";
import TabComponent from "../Tab";

const RuleTab = () => {
  const firstRules = ruleInfo.map((rule, i) => {
    return (
      <Rule
        key={i}
        heading={rule.heading}
        bulletPoints={rule.bulletPoints}
        divider={rule.divider}
      />
    );
  });

  const team = teamRules.map((rule) => {
    return (
      <Rule
        marginTop={
          rule.heading === "Playing" || "Awarding Points" ? "25px" : ""
        }
        key={nanoid()}
        heading={rule.heading}
        bulletPoints={rule.bulletPoints}
        divider={rule.divider}
      />
    );
  });

  const cutthroat = cutthroatRules.map((rule) => {
    return (
      <Rule
        marginTop={
          rule.heading === "Playing" || "Awarding Points" ? "25px" : ""
        }
        key={nanoid()}
        heading={rule.heading}
        bulletPoints={rule.bulletPoints}
        divider={rule.divider}
      />
    );
  });

  return (
    <Flex direction="column" gap="25px">
      <Heading size="lg" fontStyle="italic">
        Basics
      </Heading>
      {firstRules}
      <TabComponent
        isFitted
        variant="enclosed"
        tab1="Teams"
        tab2="Cutthroat"
        tab1Content={team}
        tab2Content={cutthroat}
        padding="0"
      />
      <Rule
        key={nanoid()}
        heading="Winning"
        bulletPoints={[
          "The game is won when a player or team reaches the predetermined winning score, typically 11, 15, or 21. If both sides reach the winning score simultaneously, the bidder for that round has the advantage and is declared the winner. Success in Setback hinges on strategic bidding; taking risks can lead to rewards, but overbidding your hand may result in a negative score. Strive for balance in bidding to avoid the unfavorable 'in the hole' situation.",
        ]}
        divider="false"
      />
    </Flex>
  );
};
export default RuleTab;
